import ItemDetailGroupType3 from "./itemDetailGroupType3";

export default ItemDetailGroupType3;
